import type { Day } from 'modules/map/components/balance-cost/types';

export const checkIfNumber = (value) => {
  if (value === undefined || value === null || value === '-' || value === '') return false;
  return !isNaN(Number(value));
};

/**
 * Ngày học sinh không ăn bán trú: không món, không thực phẩm, không chi phí phụ, không quà chiều.
 */
export const isNonEatingDay = (
  day: Pick<Day, 'dishes' | 'items' | 'additionCharges' | 'afternoons'>
) =>
  !day.dishes?.length &&
  !day.items?.length &&
  !day.additionCharges?.length &&
  !(day.afternoons ?? []).flat().length;

/**
 * Calculate the max number of rows needed for the day
 */
export const getMaxRowCounts = (count: {
  ingredients: number;
  dishes: number;
  additionCharges: number;
  afternoons: number;
}) => {
  const counts = [count.ingredients, count.dishes, count.additionCharges, count.afternoons];

  return Math.max(1, ...counts);
};
